<div class="fixed inset-0 z-50 flex items-center justify-center" role="dialog" aria-modal="true">
  <div class="absolute inset-0 bg-black/40" (click)="close()"></div>
  <div class="relative bg-white rounded-xl shadow-xl w-full max-w-md p-6 mx-4">
    <h3 class="font-semibold text-gray-900 mb-1">Save as ICP</h3>
    <p class="text-sm text-gray-500 mb-4">
      Turns this prospecting list into an Ideal Customer Profile: its leads stop expiring, and you can
      generate more or start daily automation from it.
    </p>

    <label for="save-icp-name" class="block text-sm font-medium text-gray-700 mb-1">ICP name</label>
    <input id="save-icp-name" type="text" maxlength="190"
           class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-violet-500 focus:border-violet-500 mb-3"
           [(ngModel)]="name" [disabled]="isSaving" (keydown.enter)="save()">

    <label class="flex items-center gap-2 text-sm text-gray-700 mb-3">
      <input type="checkbox" class="rounded border-gray-300 text-violet-600 focus:ring-violet-500"
             [(ngModel)]="setDefault" [disabled]="isSaving">
      Use as my default ICP
    </label>

    <p *ngIf="errorMessage" class="text-sm text-red-600 mb-3">{{ errorMessage }}</p>

    <div class="flex justify-end gap-2">
      <button type="button"
              class="px-4 py-2 rounded-lg border border-gray-300 text-sm text-gray-600 hover:bg-gray-50 disabled:opacity-50"
              [disabled]="isSaving" (click)="close()">
        Cancel
      </button>
      <button type="button"
              class="px-4 py-2 rounded-lg bg-violet-600 text-white text-sm font-medium hover:bg-violet-700 disabled:opacity-50 inline-flex items-center gap-2"
              [disabled]="isSaving || !name.trim()" (click)="save()">
        <span *ngIf="isSaving" class="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin"></span>
        {{ isSaving ? 'Saving…' : 'Save as ICP' }}
      </button>
    </div>
  </div>
</div>
